export var OfflineBehavior;
(function (OfflineBehavior) {
    /** Unknown offline behavior. */
    OfflineBehavior["UNKNOWN_OFFLINE_BEHAVIOR"] = "UNKNOWN_OFFLINE_BEHAVIOR";
    /** Allows the site visitor to write messages, but doesn't send a contact form. */
    OfflineBehavior["CHAT_ONLY"] = "CHAT_ONLY";
    /** Hides the AI Site-Chat from the site. */
    OfflineBehavior["HIDE"] = "HIDE";
    /** Doesn't allow the site visitor to write messages, but does send a contact form. */
    OfflineBehavior["CONTACT_FORM_WITHOUT_CHAT"] = "CONTACT_FORM_WITHOUT_CHAT";
    /** Allows the site visitor to write messages and sends a contact form. */
    OfflineBehavior["CONTACT_FORM_WITH_CHAT"] = "CONTACT_FORM_WITH_CHAT";
})(OfflineBehavior || (OfflineBehavior = {}));
//# sourceMappingURL=types.impl.js.map